<template>
  <div class="book">
    <div v-if="list.length === 0">
      <van-empty description="暂无餐次" />
    </div>
    <div v-for="(item, index) in list" :key="index" class="mealItem">
      <div class="left">
        <div class="head">{{ item.name }}</div>
        <div class="sub">
          <div class="name">餐次时间:</div>
          <div>
            {{ filterTime(item) }}
            <br v-if="filterTime(item).length > 8">
            {{ item.mealTimeStart }}~{{ item.mealTimeEnd }}
          </div>
        </div>
        <div class="sub">
          <div class="name">计费规则:</div>
          <div>
            {{ zh.zhCN.chargingType[item.chargingType] }}：{{ item.chargingMoney }}/次
          </div>
        </div>
        <div class="sub">
          <div class="name">支付方式:</div>
          <div>
            {{ zh.GetObjectListName(item.payTypes, 'payTypes') }}
          </div>
        </div>
      </div>
      <div class="right">
        <div @click="() => onBook(item.id)" class="book-btn">预定</div>
<!--        <van-button type="info" size="mini">预定</van-button>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mealsList } from '@/api/user';
export default {
  name: 'Book',
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      mealsList({}).then(res => {
        this.list = res.data;
      });
    },
    onBook(id) {
      this.$router.push({ name: 'mealBookForm', query: { id }});
    },
    filterTime(e) {
      const data = [];
      const list = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
      ];
      list.forEach((item) => {
        if (e[item]) {
          data.push(this.zh.zhCN.week[item]);
        }
      });
      return data.join('、');
    }
  }
};
</script>

<style lang="less" scoped>

.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}

.book {
  .mealItem {
    background: #FFFFFF;
    border: 1px solid #EFEFF4;
    box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
    opacity: 1;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    .change_margin(margin, 16, 28);
    .change_margin(padding, 25, 27);

    .left {
      width: 80%;
      .head {
        .change_val(line-height, 45);
        .change_val(font-size, 32);
        font-family: PingFang SC;
        font-weight: 400;
        color: #43425D;
        opacity: 1;
        .change_val(margin-bottom, 8);
      }

      .sub {
        .change_val(line-height, 33);
        .change_val(font-size, 24);
        .change_val(margin-bottom, 8);
        .change_val(margin-top, 8);
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.7);
        opacity: 1;
        display: flex;
        .name {
          .change_val(min-width, 124);
        }
      }
    }

    .right {
      .book-btn {
        color: #1989fa;
      }
    }
  }
}
</style>
